// ------------------------------------
// props 輸入需求 :
// props.setReturnData : function             ( 回傳列出了多少個選項 )
// ------------------------------------

import React, { useEffect, useState } from 'react';
import './_Resident.scss'
import { useTranslation } from 'react-i18next';
import ResidentRow from './ResidentRow/ResidentRow';
import sortArray from '../../actions/sortArray';
import { useSelector } from 'react-redux';

const Residents = (props) => {
    // redux
    const store_res_array = useSelector(state => state.store_residents.orign_residents_array)
    const store_users_array = useSelector(state => state.store_users.orign_users_array)
    const store_mac_alert_array = useSelector(state => state.store_mac_alert_setting.orign_macAlerts_array)
    const store_leave_hos_array = useSelector(state => state.store_residents.leave_hospital_array)
    // i18n翻譯
    const { t } = useTranslation();
    const [renderArray, setRenderArray] = useState([]); //最後結果 要去 render

    // fetch 到的完整資訊
    const [renderArray_unSort, setRenderArray_unSort] = useState([]);

    // ######## 各API取得值的useState ########
    useEffect(() => {
        let _resArr = []
        let _residnet_arr = []
        if (props.leave) { _residnet_arr = store_leave_hos_array }
        else { _residnet_arr = store_res_array }
        _residnet_arr.forEach((resident, index) => {
            // user 分配
            let _userName_from_resident_array = []
            if (resident.user_id !== null && resident.user_id !== "") {
                resident.user_id.split(",").forEach(user_from_res => {
                    store_users_array.forEach(user => {
                        if (user.role === "doctor" && user.id === Number(user_from_res)) {
                            _userName_from_resident_array.push({ first_name: user.first_name, last_name: user.last_name, role: user.role })
                        }
                    })
                })
            } else { _userName_from_resident_array.push({ first_name: "", last_name: "" }) }
            // mac alert 判斷
            let _mac_alert_type = {
                long_stay_day: false,
                leaving_overtime_day: false,
                alert_level_day: false,
                breath_low: false
            }

            if (resident.mac !== null) {
                store_mac_alert_array.forEach(mac => {
                    if (mac.mac === resident.mac) {
                        _mac_alert_type.long_stay_day = mac.long_stay_day
                        _mac_alert_type.leaving_overtime_day = mac.leaving_overtime_day
                        _mac_alert_type.alert_level_day = mac.alert_level_day
                        _mac_alert_type.breath_low = resident.breath_low

                        // if(mac.long_stay_day>=0){ _mac_alert_type.long_stay_day=true}
                        // if(mac.leaving_overtime_day>=0){ _mac_alert_type.leaving_overtime_day=true}
                        // if(mac.alert_level_day>=0){ _mac_alert_type.alert_level_day=true}
                        // if(resident.breath_low===0){ _mac_alert_type.breath_low=true}
                    }
                })
            }
            _resArr.push({
                key: index,
                data: resident,
                userData: _userName_from_resident_array,
                macData: _mac_alert_type,
            })

        })
        setRenderArray_unSort(_resArr) // 將以上資料收集成list
        props.setReturnData(_resArr.length) // 將資料"筆數"傳給搜尋欄位的component

    }, [store_res_array, store_users_array, store_mac_alert_array, props.leave])

    // ----- 排序 -----
    const [bedSort, setBedSort] = useState(false);
    const [nameSort, setNameSort] = useState(false);
    const [padSort, setPadSort] = useState(false);
    const [usersSort, setUsersSort] = useState(false);
    const [careItemsSort, setCareItemsSort] = useState(false);
    function toggleSort(_params) {
        switch (_params) {
            case "bed":
                setBedSort(!bedSort);
                if (bedSort) { sortArray.desc_through_key(renderArray_unSort) }
                else { sortArray.asc_through_key(renderArray_unSort) }
                break;
            case "name":
                setNameSort(!nameSort);
                if (nameSort) { sortArray.desc(renderArray_unSort, "last_name", "ch_char") }
                else { sortArray.asc(renderArray_unSort, "last_name", "ch_char") }
                break;
            case "pad":
                setPadSort(!padSort);
                if (padSort) { sortArray.null_first(renderArray_unSort, "mac", "str") }
                else { sortArray.null_last(renderArray_unSort, "mac", "str") }
                break;
            case "users":
                setUsersSort(!usersSort);
                if (usersSort) { sortArray.null_first(renderArray_unSort, "user_id", "str") }
                else { sortArray.null_last(renderArray_unSort, "user_id", "str") }
                break;
            case "careItems":
                setCareItemsSort(!careItemsSort);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const sortedArray = [...renderArray_unSort].sort((a, b) => {
            const dateA = new Date(a.data.updated_at);
            const dateB = new Date(b.data.updated_at);
            return dateA - dateB; // 最新的在後
        });
        setRenderArray(sortedArray.map((row, index) => {
            return (
                <ResidentRow
                    leave={props.leave}
                    key={index}
                    data={row.data}
                    userData={row.userData}
                    macData={row.macData}
                />
            )
        }))
    }, [t, nameSort, bedSort, padSort, usersSort, careItemsSort, renderArray_unSort]);

    // ----- 排序 -----
    function handleHeader(index) {
        switch (index) {
            case 1: return ["name", 'GLOBAL.NAME', nameSort] //姓名
            case 0: return ["bed", 'GLOBAL.BED_NO', bedSort] //床號
            case 2: return ["pad", 'NAV_BAR.PADS', padSort] //智慧墊
            case 3: return ["users", 'NAV_BAR.USERS', usersSort] //照護者
            case 4: return ["careItems", 'RESIDENTS.CARE_ITEMS', careItemsSort] //照護項目
            default: break;
        }
    }
    let _headerDiv = [0, 1, 2, 3, 4].map(res => {
        let _resultArray = handleHeader(res)
        return <div className="flex-grow-1 head-container" key={res} onClick={() => { toggleSort(_resultArray[0]) }}>
            <div className="head fx-ccc">
                {t(_resultArray[1])}
                {/* <div className={`tri ${_resultArray[2]?"up":"down"}`}></div> */}
            </div>
        </div>
    })
    return (
        <>
            <div className="wrap-residents fx-d-c h-100">

                {/* 各分項標頭 */}
                <div className="residents-row-head">
                    <div className='d-flex head'>
                        {_headerDiv}
                        <div className="flex-grow-2 head-container"><div className="head">{t('RESIDENTS.FUNCTION')}</div></div>
                    </div>
                </div>

                {/* 各分項內容 */}
                <div className='reset-height'>
                    {renderArray}
                </div>
            </div>
        </>
    )
}

export default Residents